export default __webpack_public_path__ + "static/media/Delivery_Mobile.c6b15513.svg";